import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { empModulo } from '../../../diccionarios/empModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ResponseRequisicionModel } from '../../../models/responseRequisicionModel';
import { ReportesService } from '../../../services/administrador/reportes.service';
import { EmpleadoModel } from '../../../models/empleadoModel';
import { DesvinculacionService } from '../../../services/administrador/desvinculacion.service';
import { CrearEmpleadoService } from '../../../services/administrador/crear-empleado.service';

@Component({
  selector: 'app-desvinculacion',
  templateUrl: './desvinculacion.component.html',
  //styleUrls: ['./desvinculacion.component.css']
})
export class DesvinculacionComponent implements OnInit {

  formulario: FormGroup;
  formularioBuscador: FormGroup;

  empModulo: any = {};

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;

  listaVacia: boolean = true;
  textoBuscar: string;
  loading: boolean = false;

  cmbSolicitante: any[] = [];
  cmbEmpresas: any[] = [];
  cmbEmpresaSolicita: any;
  cmbDepartamentoSolicita: any[];

  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private _desvinculacion: DesvinculacionService,
    private _crearEmpleado: CrearEmpleadoService
  ) { }

  ngOnInit() {
    this.empModulo = empModulo;
    this.formularioBuscador = this.fb.group({
      codEmpresa: ['']
    });
    this.formulario = this.fb.group({
      empresaSolicita: [''],
      departamentoSolicita: [''],
      codEmpleado:[''],
      codContratista: ['', [Validators.required]],
      observacion: ['', [Validators.required, Validators.maxLength(200)]],
      codSolicitante: ['', [Validators.required]],
    });
    this.cargarGrid();
    this.getEmpresasNoCorporativos();
    this.getAllEmpresaSolicita();
  }

  cargarGrid() {
    // {
    //   "codEmpleado": "1316388634",
    //   "codSolicitante": "",
    //   "codUserTransaccion": "",
    //   "descaEmpresa": "BAQUE PEREA SIMON",
    //   "desvinculado": false,
    //   "fechaIngreso": "2022-07-14",
    //   "fechaSalida": "2022-08-13",
    //   "nombres": "GILSON JEFFERSON BAQUE SANCHEZ",
    //   "observacion": "",
    //   "statusEmpleado": "Baja",
    //   "tipoEmpleado": "CONTRATISTA"
    // },
    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 200,
        cellRendererParams: {
          onClick: this.callModal.bind(this),
          label: 'Desvincular',
          colorBoton: 'btn btn-primary btn-block'
        }
      },
      {
        headerName: 'Cédula',
        field: 'codEmpleado',
        filter: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nombres',
        field: 'nombres',
        filter: true,
        width: 320,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Tipo de Empleado',
        field: 'tipoEmpleado',
        sortable: true,
        filter: true,
        width: 220,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Empresa',
        field: 'descaEmpresa',
        sortable: true,
        filter: 230,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Ingreso',
        field: 'fechaIngreso',
        sortable: true,
        filter: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Salida',
        field: 'fechaSalida',
        sortable: true,
        filter: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Solicitante',
        field: 'codSolicitante',
        filter: true,
        width: 230,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Desvinculación',
        field: 'fechaDesvinculacion',
        sortable: true,
        filter: true,
        width: 200,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Desvinculado',
        field: 'desvinculado',
        sortable: true,
        filter: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
        valueGetter: function( data ) {
          debugger
          const desvinculado = data.data.desvinculado;
          return (desvinculado)? 'SI' : 'NO'; 
        }
      },
      {
        headerName: 'Estado Empleado',
        field: 'statusEmpleado',
        sortable: true,
        filter: true,
        width: 200,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Observación',
        field: 'observacion',
        sortable: true,
        filter: true,
        width: 300,
        cellStyle: this.changeCellColor.bind(this),
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  changeCellColor(params) {
    let data = params.data;
    if (data.info != undefined) {
      if (data.info === 'false') {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return false;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getEmpresasNoCorporativos() {
    this._desvinculacion.getEmpresasNoCorporativos().subscribe((res: any[]) => {
      this.cmbEmpresas = res;
    }, (err) => {
      console.log(err);
      this.cmbEmpresas = [];
    });
  }

  getEmpleadoByEmpresa() {
    this.loading = true;
    let codEmpresa = this.formularioBuscador.get('codEmpresa').value;
    this._desvinculacion.getEmpleadosByEmpresas(codEmpresa).subscribe((res: EmpleadoModel[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = this.rowData.length === 0 ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
      this._util.mensajeErrorVisto(err.error.message);
    });
  }

  callModal({ rowData }) {
    if(rowData.desvinculado) {
      this._util.mensajeErroToast(`El empleado ${rowData.nombres} ya se encuentra desvinculado.`);
      return;
    }
    this.formulario.reset();
    // this.formulario.get('codContratista').setValue(rowData.cedula);
    this.formulario.get('codContratista').setValue(rowData.codEmpleado);
    this.formulario.get('codEmpleado').setValue(rowData.codEmpleado);
    document.getElementById('abrirModal').click();
  }

  getAllEmpresaSolicita() {
    this._crearEmpleado.getAllEmpresaSolicita().subscribe((res: any) => {
      this.cmbEmpresaSolicita = res;
    }, (err) => {
      this.cmbEmpresaSolicita = [];
      console.log(err);
    });
  }

  getDepartamentoByEmpresa() {
    const empresaSolicita =  this.formulario.get('empresaSolicita').value;
    this._crearEmpleado.getDepartamentoByEmpresa(empresaSolicita).subscribe((res: any) => {
      this.cmbDepartamentoSolicita = res.map( e => {
        e.id = e.pk.codigo;
        return e;
      });
    }, (err) => {
      this.cmbDepartamentoSolicita = [];
      console.log(err);
    });
  }

  selecionDepartamentoSolicita() {
    const departamentoSolicita = this.formulario.get('departamentoSolicita').value;
    const empresaSolicita = this.formulario.get('empresaSolicita').value;
    this._crearEmpleado.getEmployesByDepEmpColaborador(departamentoSolicita, empresaSolicita).subscribe((res: any) => {
      this.cmbSolicitante = res;
    }, (err) => {
      this.cmbSolicitante = [];
      console.log(err);
    });
  }

  desvincularEmpleado() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea desvincular al siguiente colaborador ?',
        text: '',
        action: 'Desvincular',
        funcion: this._desvinculacion.desvicularContratista(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      document.getElementById('cerrar').click();
      this.getEmpleadoByEmpresa();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });

  }

}
